/**
 * Ritmo com que o navegador repergunta ao servidor se o PDF do Certificado de Acessos ficou
 * pronto.
 *
 * Quem gera é o pdf-worker (Puppeteer), de forma assíncrona: o endpoint responde `GENERATING` e
 * o front repergunta. O backoff existe porque a primeira resposta quase nunca é a boa e o teto
 * porque worker parado não melhora com insistência — sem ele um processo travado viraria
 * requisição a cada 2 s para sempre, o defeito que a tela pública `/autenticar` já teve.
 */

/** Primeira repergunta depois do `GENERATING` inicial. */
export const PDF_CERTIFICADO_POLLING_INTERVALO_MS = 2000;

/** Intervalo máximo entre reperguntas, depois do backoff. */
export const PDF_CERTIFICADO_POLLING_INTERVALO_MAX_MS = 10000;

export const PDF_CERTIFICADO_POLLING_BACKOFF_FATOR = 1.5;

/** Teto de relógio: depois disso o navegador desiste e diz ao usuário para tentar de novo. */
export const PDF_CERTIFICADO_POLLING_TETO_MS = 2 * 60 * 1000;
